import { useEffect, useRef } from 'react';

import {
  CollectionPageBanner,
  CollectionPageHeader,
  CollectionPageMain,
  Container,
  ContainerContent,
  ContainerHeader,
} from '@/component';
import type { VFileBrowserRef } from '@/package';
import { useMainLayout } from '@/provider';

const CollectionPage = () => {
  const { setTitle } = useMainLayout();
  const fileBrowserRef = useRef<VFileBrowserRef>(null);

  useEffect(() => {
    setTitle('Collection');
  }, []);

  return (
    <Container>
      <CollectionPageBanner />
      <ContainerHeader>
        <CollectionPageHeader fileBrowserRef={fileBrowserRef} />
      </ContainerHeader>
      <ContainerContent>
        <CollectionPageMain fileBrowserRef={fileBrowserRef} />
      </ContainerContent>
    </Container>
  );
};

export default CollectionPage;
